import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { InlineErrors } from './sub-components/inline-errors';
import { FieldTitle } from './sub-components/field-title';
import { CharacterLimit } from './sub-components/character-limit';
import {
  vFParamsPropShape,
  disabledFieldOptionsShape,
} from './data-structure/v-f-proptypes';
import {
  getFieldPropShape,
  formPropShape,
} from './data-structure/formik-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/v-f-input.css';
import { SponsorIndividualApprovers } from './utility/select-sponsor-from-group';


class VFInput extends PureComponent {
  constructor(props) {
    super(props);
    this.updateValue = this.updateValue.bind(this);
    this.setTouched = this.setTouched.bind(this);
    this.sponsorHandler = this.sponsorHandler.bind(this);
  }

  componentDidMount() {
    this.ifDisabledSetDefaultValues({});
  }

  componentDidUpdate(prevProps) {
    this.ifDisabledSetDefaultValues({
      prevProps,
    });
  }

  setTouched() {
    const {
      field,
    } = this.props;

    const {
      name,
    } = field;

    this.props.form.setFieldTouched(name, true);
  }

  // Callback function to update sponsor field from child
  sponsorHandler(spoID) {
    const {
      field,
    } = this.props;

    const {
      name,
    } = field;

    const value = spoID;
    this.props.form.setFieldValue(name, value);
  }

  updateValue(e) {
    const {
      field,
    } = this.props;

    const {
      name,
    } = field;

    const value = e.target.value;

    this.props.form.setFieldValue(name, value);

    return null;
  }

  ifDisabledSetDefaultValues(params) {
    const {
      prevProps,
    } = params;
    const {
      name,
      value,
    } = this.props.field;
    const {
      disabled,
      disabledValue,
      unDisabledValue,
    } = this.props.disabledFieldOptions;
    // check if the previous props had set it to disabled
    const prevDisabled = prevProps ? prevProps.disabledFieldOptions.disabled : false;

    if (!disabled) {
      if (prevDisabled) {
        this.props.form.setFieldValue(name, unDisabledValue);
        this.props.form.setFieldTouched(name, true);
      }
      return null;
    }


    if (JSON.stringify(value) !== JSON.stringify(disabledValue)) {
      this.props.form.setFieldValue(name, disabledValue);
      this.props.form.setFieldTouched(name, true);
    }
    return null;
  }

  render() {

    const {
      vFParams,
      field,
      form,
      disabledFieldOptions,
      optional,
      readOnly,
    } = this.props;

    const {
      name,
      value,
    } = field;

    const {
      disabled,
    } = disabledFieldOptions;

    const formErrors = form.errors;
    const touched = form.touched[name];


    const errors = formErrors[name];

    const inlineErrors = errors && errors.inlineErrors ? errors.inlineErrors : null;

    const {
      fieldTitle,
      placeholder,
      characterLimit,
    } = vFParams;

    const isSponsorField = fieldTitle === 'Assign sponsor' ? true : false;

    const className = `v-f-field-type v-f-input${disabled ? ' v-f-input-disabled' : ''}${readOnly ? ' v-f-input-read-only' : ''} v-f-input-${name}`;


    return (
      <>
        {
        isSponsorField && (
        <SponsorIndividualApprovers sponsorHandler={this.sponsorHandler} />
        )
        }
        <div
          className={className}
          name={name}
        >
          {
            fieldTitle && (
              <FieldTitle
                fieldTitle={fieldTitle}
                optional={optional}
              />
            )
          }
          <div className="v-f-input-element-wrapper">
            <input
              className="v-f-input-element"
              value={value}
              onChange={this.updateValue}
              placeholder={placeholder}
              onBlur={this.setTouched}
              readOnly={readOnly}
            />
            {
              characterLimit && (
                <CharacterLimit
                  value={value}
                  characterLimit={characterLimit}
                />
              )
            }
            {
              inlineErrors && touched && (
                <InlineErrors
                  inlineErrors={inlineErrors}
                />
              )
            }
          </div>
        </div>
      </>
    );
  }
}



VFInput.propTypes = {
  vFParams: vFParamsPropShape,
  // we have to define the value within the data structure for field
  field: getFieldPropShape(PropTypes.string),
  form: formPropShape,
  disabledFieldOptions: disabledFieldOptionsShape,
  optional: PropTypes.bool,
  readOnly: PropTypes.bool,
};


const noValueVFInput = (value) => {
  if (value === null) {
    return true;
  }

  return value.trim().length < 1;
};


// This is a reference to the component. This is needed as the value for each form field is displayed on a change summary
// page but this is dependant on what type of form field is used
const VF_INPUT = 'v-f-input';

export {
  VFInput,
  noValueVFInput,
  VF_INPUT,
};
